<template>
    <el-select v-if="componentShow" ref="zmAuthTable" clearable filterable v-model="newValue" style="width: 100%;" :multiple="multiple" :disabled="selDisabled" :name="name"
               :collapse-tags="collapseTags" placeholder="" @change="selectChange">
        <el-option v-for="item in tablelist" :key="item.id" :label="item.station" :value="item.id"></el-option>
    </el-select>
</template>

<script>
    export default {
        name: "AuthStat",
        props: {
            value:{
                type:[String,Number,Array]
            },
            multiple:{
                type:Boolean,
                default:false
            },
            disabled:{
                type:Boolean,
                default:false
            },
            collapseTags:{
                type:Boolean,
                default:false
            },
            name:{
                type:String
            },
            isDefaultValue:{
                type:Boolean,
                default:true
            }
        },
        data(){
            return {
                tablelist:[],
                callValue:'',
                callLabel:'',
                disabledflag:false,
                componentShow:true
            }
        },
        computed:{
            newValue: {
                get:function() {
                    return this.value;
                },
                set:function(value) {
                    this.$emit('input', value);
                }
            },
            selDisabled:function () {
                if(!this.disabledflag && !this.disabled){
                    return false;
                }
                return true;
            }
        },
        methods: {
            getTableList(){
                var userStat = this.$util.get("userStat");
                if(userStat){
                    this.tablelist = userStat;
                    var useStat = this.$util.get("useStat");
                    if(this.isDefaultValue || this.tablelist.length == 1){
                        this.newValue = useStat.id;
                        this.selectChange(useStat.id);
                    }
                    if(this.tablelist.length < 2){
                        this.disabledflag = true;
                    }
                }
            },
            selectChange(val){
                let obj = {};
                obj = this.tablelist.find((item)=>{
                    return item.id === val;
                });
                this.$emit('change',obj);
            },
            focus(){
                this.$refs['zmAuthTable'].focus();
            },
            blur(event){
                this.$refs['zmAuthTable'].blur();
            }
        },
        created(){
            this.getTableList();
        },
        beforeDestroy(){
            this.tablelist = [];
            this.componentShow = false;
        }
    };
</script>


<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/AuthStat/index.vue